import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import logo from "../../logo.png";
import UTILS from '../../utils/commons';
import Loading from "./Loading";
import { useNavigate } from "react-router";
import { ApiClient } from "../../utils/api-client";
import { AxiosError } from "axios";
const SignupForm = ( props ) => {
  var navigate = useNavigate();
  const [ isLoading, setIsLoading ] = useState( false );
  const [ feedback, setFeedback ] = useState( "" );
  const [ showPassword, setShowPassword ] = useState( false );

  const apiClient = new ApiClient()

  const togglePasswordVisibility = () => {
    setShowPassword( !showPassword );
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading( true );
    var form = e.target;
    let fname = form.fname.value.trim();
    let lname = form.lname.value.trim();
    let email = form.email.value.trim();
    let password = form.password.value;


    let fd = { firstName: fname, lastName: lname, email: email, password: password };
    try {
      const result = await apiClient.signUp( fd );

      if ( result.status === 201 ) {
        window.sessionStorage.setItem( 'loginState', JSON.stringify( result.data.data ) );
        navigate( "/dashboard", { replace: true } );
      }
    } catch ( e ) {
      console.log( "errorDO: ", e );
      setFeedback( e instanceof AxiosError ? e.message : "Oops! Something went wrong, please try again later" );
    }
    setIsLoading( false );
  }

  return (
    <section className="h-screen w-full mx-auto p-0 flex-col justify-center items-center">
      <div className="flex flex-col justify-center items-center">
        {/* <img src={logo} alt="Rainbow logo" className="h-auto w-8/12 mx-auto my-8" /> */}
        {/* <p className="hidden md:block md:text-2xl text-center">Inventory and Distribution Management System</p> */}
        <p className="text-2xl text-center py-8">Sign Up</p>
      </div>
      <div className="bg-grey-700 text-primary p-8 rounded-lg shadow-lg w-10/12 md:w-5/12 py-16 mx-auto">
        {feedback.length > 0 ? <div className="border bg-red-200 border-red-500 text-red-500 text-center p-4 mb-4 rounded" id="feedback">{feedback}</div> : null}
        <form id="signupform" method="POST" className="md:w-6/12 mx-auto py-16" onSubmit={handleSubmit}
        >
          <div className="form-group my-2">
            <input
              type="text"
              className="form-control"
              id="fname"
              name="fname"
              placeholder="First name" required autoCapitalize="true"
            />
          </div>
          <div className="form-group my-2">
            <input
              type="text"
              className="form-control"
              id="lname"
              name="lname"
              placeholder="Last name" required autoCapitalize="true"
            />
          </div>
          <div className="form-group my-2">
            <input
              type="email"
              className="form-control"
              id="email"
              name="email"
              placeholder="E-mail" required
            />
          </div>

          <div className="form-group my-2">
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="password"
                name="password"
                placeholder="Password"
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary bg-white py-1 px-2 border-l-0 border-gray-300 rounded-r-md hover:bg-white hover:text-green-500 hover:border-gray-300 focus:outline-none focus:border-0"
                onClick={togglePasswordVisibility}
                // style={{
                //   border: '0px solid #ffffff',
                //   borderLeft: 'none',
                //   backgroundColor: '#ffffff',
                //   cursor: 'pointer',
                //   display: 'flex',
                //   alignItems: 'center',
                //   justifyContent: 'center',
                // }}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={15} /> : <Eye size={15} />}
              </button>
            </div>
          </div>
          <div className="form-group my-2 error hidden" id="error"></div>
          <div className="form-group my-2">
            {isLoading ? <Loading /> :
              <input
                type="submit"
                className="form-control bg-success"
                id="btnSignup"
                name="btnSignup"
                value="Sign up"
              />}
          </div>
          <div className="form-group my-2">
            <span>Already registered? &nbsp;<a className="link-button" href="/signin">Sign in</a></span>
          </div>
        </form>
      </div>
    </section> );
}
export default SignupForm;